import { render, staticRenderFns } from "./CertificateContent2.vue?vue&type=template&id=a399dd42&scoped=true&"
import script from "./CertificateContent2.vue?vue&type=script&lang=js&"
export * from "./CertificateContent2.vue?vue&type=script&lang=js&"
import style0 from "./CertificateContent2.vue?vue&type=style&index=0&id=a399dd42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a399dd42",
  null
  
)

export default component.exports